//初始化全局配置
export function getGlobalConfig() {
  return globalConfig;
}

export function getBaseUrl() {
  return getGlobalConfig().baseUrl;
}

/**
 * @description 格式化金额
 * @param number：要格式化的数字
 * @param decimals：保留几位小数 默认0位
 * @param decPoint：小数点符号 默认.
 * @param thousandsSep：千分位符号 默认为,
 */
export const formatMoney = (number, decimals = 0, decPoint = '.', thousandsSep = ',') => {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  let n = !isFinite(+number) ? 0 : +number
  let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  let s = ''
  let toFixedFix = function (n, prec) {
    let k = Math.pow(10, prec)
    return '' + Math.ceil(n * k) / k
  }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  let re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}
/**
 *
 * @param obj 对象/数组深拷贝
 * @returns {*}
 */
export const deepCopyObj = (obj) => {
  let newobj = obj.constructor === Array ? [] : {};
  if (obj && typeof obj !== 'object') {
    return;
  }
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      //判断ojb子元素是否为对象，如果是，递归复制
      if (obj[key] && typeof obj[key] === "object") {
        newobj[key] = deepCopyObj(obj[key]);
      } else {
        //如果不是，简单复制
        newobj[key] = obj[key];
      }
    }
  }
  return newobj
}

//截取字符串
export function cutString(str, length) {
  if (length > 0) {
    if (str != null && str.length > length) {  //字符最大长度
      str = str.substring(0, length) + "...";  //超过省略
    }
  }
  return str;
}



// WEBPACK FOOTER //
// ./src/utils/tool.js